import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { v4 } from "uuid";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { PRICE_TIER } from "../../../../constants/routes";
import { usePriceTierCreate } from "../../../../hooks/api/v2/priceTier/usePriceTierCreate";
import { formatPriceInputToApi } from "../../../../hooks/usePriceFormat";
import { PriceTierForm, PriceTierFormValues } from "../PriceTierForm";

const formId = v4();

export const PriceTierDialogCreate = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  const navigate = useNavigate();

  const form = useForm<PriceTierFormValues>();

  const priceTierCreateMutation = usePriceTierCreate();

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"New Price Tier"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />

      <DialogContent className={"flex flex-col gap-2"}>
        <PriceTierForm
          form={form}
          formId={formId}
          onSave={(data) => {
            const apiData = {
              ...data,
              minimumOrderPrice:
                formatPriceInputToApi(data.minimumOrderPrice) ?? null,
            };

            priceTierCreateMutation.mutate(apiData, {
              onSuccess: (data) => {
                navigate(PRICE_TIER.href({ priceTierId: data.id }));
                onDismiss();
              },
            });
          }}
        />

        <Alert
          message={
            "Minimum order quantities & volume discounts can be added once the price tier has been created."
          }
        />
      </DialogContent>

      <DialogCTA>
        <Button
          loading={priceTierCreateMutation.isPending}
          disabled={!form.formState.isValid}
          type={"submit"}
          form={formId}
        >
          Create
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
